import { removeCookie, writeCookie } from "./cookie.js";
import { logLevels, LogLevels } from "./level.js";
import { status, StatusObject, StatusText, updateStatus } from "./status.js";
import { noop, writeLog, Writer } from "./writer.js";

/**
 *
 *
 *
 *
 *
 *
 *
 */
export type Namespace<
  Team extends string = string,
  Service extends string = string,
  Module extends string = string,
> = `${Team}.${Service}.${Module}`;

/**
 *
 *
 *
 *
 *
 *
 *
 */
/*                                                          */
export type Logger = (...data: any[]) => void;

/**
 *
 *
 *
 *
 *
 *
 */
export interface Debug<NS extends string = Namespace> {
  /**
 *
 *
 */
  namespace: NS;

  /**
 *
 */
  trace: Logger;

  /**
 *
 */
  debug: Logger;

  /**
 *
 */
  info: Logger;

  /**
 *
 */
  warn: Logger;

  /**
 *
 */
  error: Logger;

  /**
 *
 *
 */
  /*                                                          */
  log: (level: LogLevels, ...data: any[]) => void;

  /**
 *
 *
 *
 *
 */
  scope: <Scope extends string>(scope: Scope) => Debug<`${NS}.${Scope}`>;
}

/*                                   */
let write: Writer = noop;

/**
 *
 *
 *
 *
 */
export function logger<NS extends string = Namespace>(namespace: NS): Debug<NS> {
  const loggers = Object.fromEntries(
    /*                                                          */
    logLevels.map((l) => [l, ((...data) => write(l, namespace, data)) as Logger]),
  );

  return {
    namespace,
    ...loggers,
    log: (level, ...data) => write(level, namespace, data),
    scope: (scope) => logger(`${namespace}.${scope}`),
  };
}

export function updateLogger(state: StatusObject): StatusObject {
  write = state.activated ? writeLog : noop;
  return state;
}

/**
 *
 *
 *
 *
 *
 *
 */
export function activate(namespace?: string | RegExp, level?: LogLevels): StatusText {
  /*                        */
  const ns = namespace || ".*";

  /*                                */
  status();
  /*               */
  writeCookie(ns, level);
  /*              */
  const state = updateStatus(new RegExp(ns), level);

  return updateLogger(state).text;
}

/**
 *
 *
 *
 */
export function deactivate(): StatusText {
  /*                               */
  status();

  /*            */
  removeCookie();

  /*              */
  const state = updateStatus(undefined);

  return updateLogger(state).text;
}

/**
 *
 *
 *
 */
export function warn(message: string): void {
  if (status().activated) {
    /*                                  */
    console.warn(message);
  }
}
